module.exports = __webpack_public_path__ + "files/8da7ad7327a0266fc4b1928083c605d5.png";